<template>
  <span>
    <a-popover placement="topLeft" v-if="isPopover">
      <template slot="content">
        <div style="width: 200px">
          <a-row v-for="(item, index) in popLists" :key="index">
            <a-col :span="8" style="text-align: right; font-weight: bold">{{ item.langType }}：</a-col>
            <a-col :span="16">{{ item.langText }}</a-col>
          </a-row>
        </div>
      </template>
      <a-button v-bind="$attrs" v-on="$listeners">{{ langText }}</a-button>
    </a-popover>
    <a-button v-else v-bind="$attrs" v-on="$listeners">{{ langText }}</a-button>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'mtcButton',
  data() {
    return {
      secondLanguage: JSON.parse(this.$ls.get('secondLanguage')) || []
    }
  },
  computed: {
    langText() {
      return this.$t(this.$attrs.text) || this.$attrs.text
    },
    popLists() {
      let secondLanguage = JSON.parse(this.$ls.get('secondLanguage')) || []
      let secondLabel = []
      if (!this.$attrs.text) return
      secondLanguage.forEach(ele => {
        secondLabel.push({
          langType: ele,
          langText: this.$t(this.$attrs.text, ele) || this.$t('tip.noData')
        })
      })
      return secondLabel
    },
    isPopover(){
      // 开启多语言 并且 有次语言
      return this.secondLanguage.length && this.$getLanguageEnable()
    }
  }
}
</script>

<style lang="less">
.ant-btn-link {
  padding: 0;
}
</style>